module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "cabecalho-sistema cabecalho-sistema_fixo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cabecalho-sistema__container-secundario"
  }, [_c('nav', {
    staticClass: "cabecalho-sistema__menu"
  }, [_c('ul', {
    staticClass: "cabecalho-sistema__lista-de-itens"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown_direita"
  }, [_c('button', {
    staticClass: "cabecalho-sistema__item-de-menu",
    attrs: {
      "aria-label": "Opções para o usuário Administrador",
      "aria-haspopup": "true"
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "cabecalho-sistema__nome-do-usuario"
  }, [_vm._v(_vm._s(_vm.usuarioLogado()))]), _vm._v(" "), _c('i', {
    staticClass: "far fa-angle-down u-margem-esquerda-pequena"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown__lista",
    attrs: {
      "aria-label": "Submenu"
    }
  }, [_c('li', {
    staticClass: "dropdown__item"
  }, [_c('a', {
    staticClass: "dropdown__link",
    attrs: {
      "href": _vm.politicaPrivacidadeUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "far fa-lock dropdown__icone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Política de privacidade\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown__item"
  }, [_c('a', {
    staticClass: "dropdown__link",
    attrs: {
      "href": _vm.termoDeUsoUrl,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "far fa-file-check dropdown__icone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                  Termo de uso\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown__item"
  }, [_c('a', {
    staticClass: "dropdown__link",
    attrs: {
      "href": _vm.alterarSenhaUrl
    }
  }, [_c('i', {
    staticClass: "far fa-exchange dropdown__icone"
  }), _vm._v("\n                  Alterar senha\n                ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown__item"
  }, [_c('a', {
    staticClass: "dropdown__link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-sign-out dropdown__icone"
  }), _vm._v("\n                  Sair\n                ")])])])])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "menu-lateral menu-lateral_fixo menu-lateral_minimizado no-print"
  }, [_c('menu', {
    staticClass: "menu menu-lateral__lista"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('menuitem', {
      key: menu.id,
      staticClass: "menu-lateral__item",
      on: {
        "click": function($event) {
          return _vm.ativarMenu(menu.id)
        }
      }
    }, [(_vm.usuarioPossuiAlgumaPermissao(menu.permissoes)) ? _c('router-link', {
      staticClass: "menu-lateral__link",
      class: _vm.menuAtivo === menu.id ? 'menu-lateral__link_ativo' : '',
      attrs: {
        "to": {
          name: menu.link
        },
        "title": menu.descricao
      }
    }, [_c('i', {
      staticClass: "menu-lateral__icone",
      class: menu.icone,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "menu-lateral__texto"
    }, [_vm._v(_vm._s(menu.descricao))])]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "pagina__conteudo-container"
  }, [_c('main', {
    staticClass: "pagina__conteudo-principal"
  }, [_c('header', {
    staticClass: "barra-navegacao no-print"
  }, [_c('div', {
    staticClass: "barra-navegacao__container"
  }, [_c('div', {
    staticClass: "barra-navegacao__conteudo-primario"
  }, [(!_vm.$route.meta.ocultarBotaoVoltar) ? _c('a', {
    staticClass: "barra-navegacao__botao-voltar",
    attrs: {
      "href": "#",
      "aria-label": "Voltar"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "barra-navegacao__container-titulos sub-menu-categoria"
  }, [_c('ul', {
    staticClass: "barra-navegacao__rastro"
  }), _vm._v(" "), _c('cabecalho-do-conteudo', {
    staticClass: "barra-navegacao__titulo"
  }), _vm._v(" "), _c('h1', {
    staticClass: "barra-navegacao__titulo",
    attrs: {
      "id": "titulo-da-pagina"
    }
  })], 1)])])]), _vm._v(" "), _c('div', [_c('router-view')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sobreposicao"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cabecalho-sistema__container-primario"
  }, [_c('button', {
    staticClass: "botao-hamburguer",
    attrs: {
      "aria-label": "Menu principal"
    }
  }, [_c('span', {
    staticClass: "botao-hamburguer__linha-1"
  }), _vm._v(" "), _c('span', {
    staticClass: "botao-hamburguer__linha-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "botao-hamburguer__linha-3"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "cabecalho-sistema__logo",
    attrs: {
      "src": require("../../assets/imagens/logo-habix.svg"),
      "alt": "Logo do sistema"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "botao-abrir-suporte-online"
    }
  }, [_c('a', {
    staticClass: "cabecalho-sistema__item-de-menu",
    attrs: {
      "href": "https://somosdigix.movidesk.com/form/5822/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('i', {
    staticClass: "fal fa-question-circle fa-lg u-margem-direita-mini",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Suporte\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cabecalho-sistema__icone-do-usuario"
  }, [_c('i', {
    staticClass: "far fa-user"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ff822b9c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff822b9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Layout.vue
// module id = 1148
// module chunks = 1